export const config = {
  appId: process.env.REACT_APP_O365_CLIENT || "",
  appUserId: process.env.REACT_APP_O365_USER || "",
  redirectUri: process.env.REACT_APP_O365_REDIRECT,
  scopes:
    "User.Read profile openid offline_access Calendars.ReadWrite.Shared User.ReadBasic.All",
};
